import { motion } from 'framer-motion';

const CompanyInfo = () => {
  const companyData = [
    { label: '事業所名', value: 'ヘルパーステーションおかやま' },
    { label: '運営会社', value: 'おかやま訪問介護株式会社' },
    { label: '代表取締役', value: '岡山太郎' },
    { label: '所在地', value: '岡山市北区○○町1-2-3' },
    { label: '電話番号', value: '086-012-3456' },
    { label: 'FAX', value: '086-012-3457' },
    { label: '設立', value: '2020年' },
    { label: '従業員数', value: '5名' },
    { label: '営業時間', value: '9:00 〜 18:00' },
    { label: '定休日', value: '日曜日・祝日' },
  ];

  const certifications = [
    '介護保険事業者指定',
    '訪問介護事業所指定',
    '岡山県介護サービス事業者協会会員',
    '全国訪問介護事業者協議会会員',
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 代表挨拶 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 sm:mb-20"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-10 sm:mb-12 text-center px-4">
            代表挨拶
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className="w-full h-64 sm:h-80 lg:h-96 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/4e6e0186dc5589e7d43e2903c57d72d4.jpg"
                alt="代表取締役 岡山太郎"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-navy-800 mb-5 px-4 sm:px-0">
                地域の皆様に寄り添う介護サービスを
              </h3>
              <div className="space-y-4 text-sm sm:text-base text-navy-700 leading-relaxed px-4 sm:px-0">
                <p>
                  ヘルパーステーションおかやまのホームページをご覧いただき、誠にありがとうございます。代表取締役の岡山太郎です。
                </p>
                <p>
                  当事業所は2020年の設立以来、岡山市北区の皆様に寄り添った訪問介護サービスを提供してまいりました。高齢化が進む中、住み慣れた地域で安心して暮らし続けたいという思いは、誰もが持つ願いです。
                </p>
                <p>
                  私たちは、お客様一人ひとりの尊厳を大切にし、その方らしい生活を支えることを使命としています。経験豊富なスタッフが、真心を込めてサポートいたします。
                </p>
                <p>
                  岡山市北区で訪問介護サービスをお探しの方は、ぜひお気軽にご相談ください。
                </p>
                <p className="font-bold pt-3">
                  代表取締役　岡山太郎
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* 会社情報 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 sm:mb-20"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-10 sm:mb-12 text-center px-4">
            会社情報
          </h2>
          <div className="bg-beige-50 rounded-2xl p-6 sm:p-8 lg:p-10">
            <div className="space-y-5">
              {companyData.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-center border-b border-beige-200 pb-5 last:border-b-0 last:pb-0"
                >
                  <div className="w-full sm:w-40 font-bold text-navy-800 mb-2 sm:mb-0 flex-shrink-0 text-sm sm:text-base">
                    {item.label}
                  </div>
                  <div className="flex-1 text-navy-700 break-words text-sm sm:text-base">
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* 資格・認可 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-10 sm:mb-12 text-center px-4">
            資格・認可・加入団体
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="bg-beige-50 rounded-xl p-5 sm:p-6 flex items-center"
              >
                <i className="ri-shield-check-line text-2xl sm:text-3xl text-coral-500 mr-4 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-navy-800 font-medium">
                  {cert}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CompanyInfo;
